import React from "react";
import "./Benefits.scss";
import { benefitData } from "../../data/data";

const Benefits = () => {
  return (
    <section className="section benefit">
      <article className="benefit__container container">
        <div className="section__header">
          <h1 className="section__title">Why attend TEDxOAU</h1>
          <p className="section__title-center">
            Here are some of the benefits you stand to gain from attending
            TEDxOAU
          </p>
        </div>

        <div className="benefit__container--content">
          {benefitData.map((benefit, index) => {
            const { icon, title, description } = benefit;
            return (
              <div
                className="benefit-card"
                data-aos="fade-down"
                data-aos-easing="ease"
                key={title}
              >
                <div className="benefit-card-inner">
                  <div className="benefit-card-front">
                    <div className="benefit-card__icon flex">{icon}</div>

                    <div className="benefit-card__body">
                      <h3>{title}</h3>
                    </div>
                  </div>
                  <div className="benefit-card-back">
                    <p>{description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </article>
    </section>
  );
};

export default Benefits;
